const isUrclyrd = (process.env.REACT_APP_VARIANT || '').toUpperCase() === 'URCLYRD';

export default {
  Email: '电子邮件',
  Password: '密码',
  Login: '登录',
  "You don't have an account?": '您还没有账户吗？',
  'Register here': '在此注册',
  Role: '角色',
  Name: '姓名',
  Save: '保存',
  Surname: '姓氏',
  'Confirm password': '确认密码',
  Register: '注册',
  'Already have an account?': '已有账户？',
  'sign in': '登录',
  'My profile': '我的个人资料',
  Logout: '登出',
  'Change password': '更改密码',
  'Your profile picture was updated': '您的个人头像已更新',
  'Your profile information was updated': '您的个人信息已更新',
  'New password': '新密码',
  'Confirm new password': '确认新密码',
  'Your password has been changed': '您的密码已更改',
  Cancel: '取消',
  'Update information': '更新信息',
  'Upload new picture': '上传新照片',
  'Pending invitations for today': '今日待处理邀请',
  'There are no pending invitations for today': '今日无待处理邀请',
  'My buildings': '我的大楼',
  'My invitations': '我的邀请',
  'No buildings were found': '未找到任何大楼',
  Home: '主页',
  'Building detail': '大楼详情',
  Address: '地址',
  Manager: '经理',
  'My user roles in this building': '我在此大楼的用户角色',
  COMPANY_SECRETARY: '公司秘书',
  BUILDING_MANAGER: '大楼经理',
  'BUILDING_MANAGER.description': '管理大楼信息、用户、公司，访问大楼并创建访问邀请的权限',
  COMPANY_MANAGER: '公司经理',
  'COMPANY_MANAGER.description': '管理公司信息、用户，访问大楼并创建访问邀请的权限',
  EMPLOYEE: '大楼员工',
  'EMPLOYEE.description': '访问大楼的权限',
  HOST_EMPLOYEE: '具有访客接待权限的大楼员工',
  'HOST_EMPLOYEE.description': '访问大楼并创建访问邀请的权限',
  SECURITY: '大楼安保人员',
  'SECURITY.description': '访问大楼、创建邀请并允许其他用户进入的权限',
  Edit: '编辑',
  'Manage companies': '管理公司',
  'No records found': '未找到记录',
  'My roles': '我的角色',
  'Manage users': '管理用户',
  Detail: '详情',
  'The building information has been updated': '大楼信息已更新',
  "Building's users": '大楼用户',
  'Go to detail': '查看详情',
  'Add user to building': '将用户添加至大楼',
  'Add user': '添加用户',
  'Remove user': '移除用户',
  Remove: '移除',
  'User email': '用户电子邮件',
  'The user has been added to the building': '用户已添加至大楼',
  'The user has been removed from the building': '用户已从大楼移除',
  'Remove user from building?': '从大楼移除用户？',
  'Remove user from company?': '从公司移除用户？',
  Yes: '是',
  No: '否',
  'My companies': '我的公司',
  Companies: '公司',
  'Edit company': '编辑公司',
  'Create company': '创建公司',
  'Manager email': '经理电子邮件',
  'The company has been added to the building': '公司已添加至大楼',
  'The company has been updated': '公司信息已更新',
  'The user has been added to the company': '用户已添加至公司',
  'The user has been removed from the company': '用户已从公司移除',
  'Add user to company': '将用户添加至公司',
  "Company's users": '公司用户',
  "Back to the building's companies": '返回大楼公司列表',
  'My user roles in this company': '我在此公司的用户角色',
  'Company detail': '公司详情',
  'New invitation': '新邀请',
  'The invitation has been sent': '邀请已发送',
  Building: '大楼',
  Host: '访客接待人',
  'You do not have invite permissions in any building': '您在任何大楼中都没有邀请权限',
  "Guest's email": '访客电子邮件',
  Guest: '访客',
  'Invitation date': '时间',
  'As myself': '以我自己的名义',
  'Invitation subject/reason': '邀请主题/事由',
  'Invitation duration': '邀请时长',
  'Modify meeting': '更新',
  '1 hour': '1 小时',
  '2 hours': '2 小时',
  '3 hours': '3 小时',
  '5 hours': '5 小时',
  '12 hours': '12 小时',
  Notes: '备注',
  'Allow access to the building for': '允许进入大楼时长',
  'Create invitation': '创建邀请',
  'Invitation detail': '邀请详情',
  Date: '日期',
  hours: '小时',
  'Access allowed for': '允许访问时长',
  'You are hosting': '您邀请的',
  Confirmed: '已确认',
  'Waiting confirmation': '等待确认',
  Rejected: '已拒绝',
  Cancelled: '已取消',
  Status: '状态',
  'Subject/Reason': '主题/事由',
  'Sent to': '发送至',
  'Sent date': '发送日期',
  'I forgot my password': '我忘记了密码',
  'Password recovery': '密码恢复',
  'Input your email and we will send you a link to restore your password':
    '输入您的电子邮件，我们将向您发送一个链接以重置您的密码',
  Back: '返回',
  'Information was sent on how to restore your password': '关于如何重置密码的信息已发送',
  'Request password recovery': '请求密码恢复',
  'Your password as been restored. You can now access with your new password':
    '您的密码已重置。您现在可以用新密码登录了',
  'Your email has been verified': '您的电子邮件已验证',
  'The email could not be verified': '该电子邮件无法验证',
  'Verify email': '验证电子邮件',
  PAST_DUE: '已过期',
  CANCELLED: '已取消',
  REJECTED: '已拒绝',
  CONFIRMED: '已接受',
  PENDING: '待定',
  Confirm: '确认',
  Reject: '拒绝',
  'The assistance to the invitation has been confirmed': '已确认参加邀请',
  'Confirm assistance?': '确认参加？',
  'The invitation has been cancelled': '邀请已取消',
  'Cancel invitation?': '接待人将收到您拒绝此邀请的通知。确认拒绝吗？',
  'The invitation has been rejected': '邀请已拒绝',
  'Reject invitation?': '接待人将收到您拒绝此邀请的通知。确认拒绝吗？',
  Required: '必填',
  'Invalid email': '无效的电子邮件',
  'Password confirm does not match': '密码确认不匹配',
  'Select a building': '选择一栋大楼',
  Cellphone: '手机号码',
  Birthdate: '出生日期',
  Habilitaçao: '驾驶执照号码 (CNH)',
  'RNE number': '外国人登记号码 (RNE)',
  'ID Type': '政府身份证件',
  'RG number': '身份证号码 (RG)',
  RG: '身份证 (RG)',
  RNE: '外国人身份证 (RNE)',
  Passport: '护照',
  'CPF number': '个人税务登记号 (CPF)',
  'Invalid ID number': '无效的身份证号码',
  'Invalid CPF number': '无效的个人税务登记号 (CPF)',
  Secretary: '秘书',
  'My secretaries': '设置代理人',
  'New secretary': '新联系人',
  'The user has been added as a secretary': '用户已添加为秘书',
  'No results': '无结果',
  'Search and select an user': '搜索并选择一个用户',
  'The user has been removed from your secretaries': '用户已从您的秘书列表中移除',
  'Remove user from your secretaries?': '从您的秘书列表中移除该用户？',
  '1. Select the building': '1. 选择大楼',
  '2. Search a user and select from the list': '2. 搜索用户并从列表中选择',
  'Send invitation as yourself or acting as a secretary for another user':
    '以您自己或代表其他用户的名义发送邀请',
  'Send invitation as': '代表...发送邀请',
  'Building not found': '未找到大楼',
  'Invalid token': '无效的令牌',
  Forbidden: '禁止访问',
  "There's no user registered with that email": '没有使用该电子邮件注册的用户',
  'Email or password incorrect': '电子邮件或密码不正确',
  'The building manager can not be removed': '大楼经理无法被移除',
  'Company not found': '未找到公司',
  'The company manager can not be removed': '公司经理无法被移除',
  'You cannot invite in this building': '您不能在此大楼中发出邀请',
  'The user cannot invite in this building': '该用户不能在此大楼中发出邀请',
  'Missing file': '缺少文件',
  'You can not cancel a past invitation': '您不能取消过去的邀请',
  'The invitation can not be cancelled': '该邀请无法取消',
  'You can not reject your own invitation': '您不能拒绝自己的邀请',
  'You can not reject a past invitation': '您不能拒绝过去的邀请',
  'The invitation can not be rejected': '该邀请无法拒绝',
  'You can not confirm your own invitation': '您不能确认自己的邀请',
  'You can not confirm a past invitation': '您不能确认过去的邀请',
  'The invitation can not be confirmed': '该邀请无法确认',
  'Invitation not found': '未找到邀请',
  "Can't create invitations on behalf user": '无法代表用户创建邀请',
  "The user can't create invitations in this building": '该用户无法在此大楼中创建邀请',
  'You are not allowed to perform this action': '您无权执行此操作',
  'Multiple emails separated by comma': '多个电子邮件，用逗号分隔',
  'Sent invitations': '已发送的邀请',
  'Received invitations': '收到的邀请',
  'Invitation data': '邀请数据',
  'Account configuration': '设置',
  'My information': '我的信息',
  Account: '账户设置',
  'My vehicle': '我的车辆',
  'Your vehicle information was updated': '您的车辆信息已更新',
  Make: '品牌',
  Model: '型号',
  Color: '颜色',
  'License plate': '车牌号',
  'The documents were uploaded': '文件已上传',
  'My documents': '我的文件',
  'ID Front': '更新身份证正面照片',
  'ID Back': '更新身份证背面照片',
  'Email or cellphone number': '电子邮件或手机号码',
  'If using a cellphone number, it must be valid and include both country and area code. Ex (5511943210091)':
    '如果使用手机号码，必须有效并包含国家和地区代码。例如 (8613812345678)',
  'Verify cellphone': '验证手机',
  'Your cellphone has been verified': '您的手机已验证',
  'The cellphone could not be verified': '手机无法验证',
  'A message was sent to your number with a verification code':
    '一条带有验证码的消息已发送至您的号码',
  Skip: '跳过',
  'Cellphone number': '手机号码',
  'Only numbers. Including country and area code': '仅限数字。包括国家和地区代码',
  'Verify cellphone number': '验证手机号码',
  'Your cellphone is already verified': '您的手机已经过验证',
  'Request verification code': '请求验证码',
  'Verification code': '验证码',
  Verify: '验证',
  'Invalid number': '无效号码',
  'Invalid email or cellphone': '无效的电子邮件或手机',
  'Change email': '更改电子邮件',
  'Change phone': '更改电话号码',
  'We have sent an email to your new email address. The change will be efective once you verify this new email':
    '我们已向您的新电子邮件地址发送了一封邮件。一旦您验证了新邮箱，更改即会生效',
  'Your phone number has been changed': '您的电话号码已更改',
  'After you submit we will send a verification link to this new email address. The change will only be effective after you have verified this new email address.':
    '您将在下面的电子邮件中收到一个验证链接。只有在您点击该链接后，电子邮件的更改才会生效。',
  'Min 8 characters, one uppercase, one lowercase and one number':
    '最少8个字符，至少一个大写字母和一个数字',
  'The token you are trying to use is not valid': '您尝试使用的令牌无效',
  Access: '访问',
  'There are not access codes available for the selected building': '所选大楼没有可用的访问代码',
  'Company role': '公司角色',
  Company: '公司',
  Accept: '接受',
  'Terms and Conditions': '我已阅读并同意条款和条件',
  'Privacy policy': '我已阅读并同意隐私政策',
  'SMS consent': '我同意接收来自 {{brand}} 的自动短信，用于账户验证和安全目的',
  'SMS consent modal title': '为什么需要短信同意？',
  'SMS consent modal body':
    '勾选此框即表示您同意接收来自 {{brand}} 的自动短信，用于账户验证和安全目的。可能适用短信和数据费用。回复 STOP 可取消订阅。回复 HELP 或发送电子邮件至 <2>{{helpEmail}}</2> 获取帮助。条款和隐私政策请访问：<0>条款</0> 和 <1>隐私政策</1>。',
  Close: '关闭',
  'There was changes in our Terms of service and Privacy Policy. Please review them and make sure you accept them before you continue using our application.':
    '条款和条件以及隐私政策已更新。',
  'Changes in Terms of service and Privacy Policy': '服务条款和隐私政策变更',
  'Delete my account': '删除我的账户',
  'Your account has been deleted.': '您的账户已被删除。',
  'Deleting your account is irreversible. All your data will be lost, including your personal information, invitations you sent and received, associations to buildings and secretaries.':
    '删除您的账户是不可逆转的。您的所有数据都将丢失，包括您的个人信息、您发送和接收的邀请、与大楼和秘书的关联。',
  'Input your password to delete the account': '输入您的密码以删除账户',
  'I understand. Delete my account': '我明白。删除我的账户',
  Invitations: '邀请',
  Invitation: '邀请',
  'The access code is being generated and will be visible here when the invitation date is due The access code is being generated and will be visible here when the invitation date is due':
    '访问代码正在生成中，并将在邀请日期到期时在此处显示',
  "Host's email": '接待人电子邮件',
  "Host's cellphone": '接待人手机',
  'View invitation full detail': '查看邀请全部详情',
  'The access code will be visible here once the invitation is confirmed':
    '邀请确认后，访问代码将在此处显示',
  'Download the app here': isUrclyrd ? '在此下载 Urclyrd 应用' : '在此下载 Podesubir 应用',
  'My Badge': '我的徽章',
  Visitor: '访客',
  Meetings: '会议',
  'New meeting': '新会议',
  'Other guests': '其他访客',
  ACTIVE: '等待确认',
  Invited: '已邀请',
  'Multiple emails/cellphones separated by comma': isUrclyrd
    ? '多个电子邮件、ID 或手机号码，用逗号分隔'
    : '多个电子邮件、CPF 或手机号码，用逗号分隔',
  "Guest's contact": '访客联系方式',
  'Create meeting': '创建会议',
  Guests: '访客',
  'The meeting has been modified': '会议已修改',
  'Remove guest from the meeting?': '从会议中移除访客？',
  'Remove guest from the meeting': '从会议中移除访客',
  'Cancel meeting?': '访客将收到您取消此邀请的通知。确认取消吗？',
  'The meeting has been cancelled': '会议已取消',
  'Add guests to the meeting': '向会议添加访客',
  Add: '添加',
  'For security reasons we encourage you to change your password.':
    '出于安全原因，我们建议您更改密码。',
  None: '无',
  Floor: '楼层',
  Room: '房间/办公室',
  'Main company': '主要公司',
  'Allow access before meeting starts (minutes)': '允许在会议开始前（分钟）进入',
  'Meetings & Invitations': '会议与邀请',
  'There are no more records': '没有更多记录了',
  'You were invited': '您被邀请了',
  'Invited by': '邀请人',
  'your best welcome': '致以最诚挚的欢迎',
  'Sign up': '注册',
  'Meeting date': '时间',
  terms: '条款和条件',
  privacypolicy: '隐私政策',
  'New email': '新电子邮件',
  'New cellphone number': '新手机号码',
  Attention: '注意',
  'Date from': '起始日期',
  'Date to': '结束日期',
  'Group data by': '按...分组数据',
  Month: '月',
  Week: '周',
  Day: '日',
  Hour: '小时',
  Show: '显示',
  'Show Filters': '显示筛选器',
  'Visitors by building': '按大楼分的访客',
  'My stats': '我的报告',
  Visitors: '访客',
  'Visitors stay': '访客停留时间',
  week: '周',
  of: '的',
  Stats: '报告',
  'Average duration (minutes)': '平均时长（分钟）',
  'Average visits duration': '平均访问时长',
  Stay: '停留',
  'You need to be building manager to see reports': '您需要成为大楼经理才能查看报告',
  Sent: '已发送',
  Received: '已接收',
  All: '全部',
  Pending: '待定',
  'Your profile has been rejected for the following reasons': '您的个人资料因以下原因被拒绝',
  'Please complete all of your profile information in order to start using Podesubir':
    '请完成您的所有个人资料信息以开始使用 Podesubir',
  'Missing fields': '缺失/无效字段',
  'Your profile is under review. You will receive a response within 24hs':
    '您的个人资料正在审核中。您将在24小时内收到回复',
  'Profile picture': '个人头像',
  'ID number': '身份证号码',
  'Documets ID Front picture': '身份证正面照片',
  'Documents ID Back picture': '身份证背面照片',
  'Click here to correct the relevant fields': '点击此处更正相关字段',
  'Email verification': '电子邮件验证',
  'Cellphone verification': '手机验证',
  'Basic information': '个人信息',
  'ID documents': '身份证件',
  Finalize: '完成',
  'We have sent you an email to your address': '我们已向您的地址发送了一封电子邮件',
  'Please follow the instructions and click on continue': '请按照说明操作并点击继续',
  'If you did not received the email you can': '如果您没有收到电子邮件，您可以',
  'request a new verification email': '请求新的验证电子邮件',
  'Alternatively you can': '或者您可以',
  'change your email address': '更改您的电子邮件地址',
  Continue: '继续',
  'A new email was sent to your address': '一封新邮件已发送到您的地址',
  'Change email address': '更改电子邮件地址',
  'Your email address was changed and a new verification email was sent':
    '如果您输入错误或想更改您的电话号码',
  'If you made a mistake or want to change your phone number': '如果您输入错误或想更改您的电话号码',
  'Change cellphone': '更改手机',
  'We will now verify your cellphone number': '我们现在将验证您的手机号码',
  'We will send you a 4 digit verification code via SMS': '我们将通过短信向您发送一个4位数的验证码',
  'I am ready, send me the verification code': '我准备好了，请发送验证码',
  'click here': '点击这里',
  'Change cellphone number': '更改手机号码',
  'An SMS was sent to your cellphone with the verification code':
    '一条带有验证码的短信已发送到您的手机',
  'Invalid code': '输入的验证码无效或已过期。请检查您的短信收件箱并在必要时请求新的短信',
  'Your cellphone number was changed and a new verification sms was sent':
    '您的手机号码已更改，并已发送新的验证短信',
  'Country of residence': '居住国',
  'cpf is a required field': '必填',
  'Your face must be visible and centered in the picture frame': '您的脸部必须在相框中可见且居中',
  'No other people should be visible in the picture': '照片中不应出现其他人',
  'Position your face within the crop area': '请将脸部对准并置于裁剪区域内',
  'The picture must match the picture in the ID documents from the next step':
    '照片必须与下一步骤中身份证件上的照片匹配',
  'Take picture': '拍照',
  NO_FACES: '照片中未检测到人脸。请阅读说明并重试',
  MULTIPLE_FACES: '照片中检测到多张人脸。请阅读说明并重试',
  'Confirm and save': '确认并保存',
  'Make sure the ID pictures are clear and all the information can be seen':
    '确保身份证照片清晰，所有信息可见',
  'The face in the front of the ID must match your profile picture':
    '身份证正面的脸部必须与您的个人头像匹配',
  'The information in the ID must match the information you provided in the previous step':
    '身份证上的信息必须与您在上一步中提供的信息匹配',
  'ID picture front': '身份证正面照片',
  'ID picture back': '身份证背面照片',
  'You have completed all the registration steps': '您已完成所有注册步骤',
  'If you would like to change any information you can go back to a previous step':
    '如果您想更改任何信息，可以返回上一步',
  'When you are ready, press finalize to complete the process': '准备好后，按“完成”以结束流程',
  MISSING_REVIEW_CORRECTIONS: '在提交之前，仍有个人资料更正待处理',
  FACE_DOESNT_MATCH: '您提供的个人头像照片与您提供的身份证正面文件照片不匹配',
  INFORMATION_DOESNT_MATCH: '“个人信息”中提供的部分信息与您的身份证件信息不符。',
  'There was a validation error with the information provided': '提供的信息存在验证错误',
  'Go back to the previous steps and correct the information': '返回上一步并更正信息',
  'If the information supplied is correct, click the following button to submit everything as is and a customer support representative will review your profile':
    '如果提供的信息正确，请点击以下按钮提交所有内容，客户支持代表将审核您的个人资料',
  'Submit my profile for review': '提交我的个人资料以供审核',
  'Your profile is under review by a customer service representative. We will notify you via email once the review is complete':
    '您的个人资料正在由客户服务代表审核。审核完成后，我们将通过电子邮件通知您',
  'Your profile has been rejected by a customer support representative':
    '您的个人资料已被客户支持代表拒绝',
  'Please correct the following fields and re-submit your profile to be reviewed again':
    '请更正以下字段并重新提交您的个人资料以供再次审核',
  name: '姓名',
  surname: '姓氏',
  company: '公司',
  company_role: '公司角色/职位',
  birthdate: '出生日期',
  id_type: '身份证件类型',
  id_number: '身份证号码',
  cpf: 'CPF 号码',
  profile_picture: '个人头像',
  ID_FRONT: '身份证正面',
  ID_BACK: '身份证背面',
  'You have performed all the requested corrections. Submit your profile for review':
    '您已完成所有要求的更正。提交您的个人资料以供审核',
  'Your profile is now complete and your account verified. You can start using podesubir':
    '您的个人资料现已完整，账户已验证。您可以开始使用 podesubir',
  true: '与文件照片中的信息不符',
  'Access code': '访问代码',
  employees: '员工',
  Filter: '筛选',
  Roles: '角色',
  'Roles in the building': '在大楼中的角色',
  users: '用户',
  Users: '用户',
  next: '下一个',
  'your session expired. Please log in again':
    '您的会话已超时并为了您的安全而结束。要查看您的凭据和会议，请重新登录',
  'You are trying to log in from an unknown device. We have sent you an email with a verification code. Please input the code below to complete your login':
    '您正试图从未知的设备登录。我们已向您发送了一封带有验证码的电子邮件。请输入下面的代码以完成登录',
  'Go back': '回去',
  INVALID_AUTH: '用户名或密码不正确',
  EMAIL_ALREADY_VERIFIED: '该电子邮件地址已经过验证',
  CELLPHONE_ALREADY_VERIFIED: '该手机号码已经过验证',
  INVALID_TOKEN: '令牌无效',
  FORBIDDEN: '您无权执行此操作',
  USER_NOT_FOUND: '未找到用户',
  NOT_FOUND: '未找到',
  MEETING_IS_PAST: '会议已过去。无法执行该操作',
  MISSING_INVITATIONS_PERMISSIONS: '缺少此大楼的邀请权限',
  USER_IS_NOT_GUEST: '您不是此邀请的访客。无法执行该操作',
  PAST_DUE: '会议已过去。无法执行该操作',
  CONFIRMATION_FAILED: '邀请无法确认',
  REJECTION_FAILED: '邀请无法拒绝',
  CANCELLATION_FAILED: '邀请无法取消',
  EMAIL_ALREADY_IN_USE: '您输入的电子邮件地址已被使用',
  CELLPHONE_ALREADY_IN_USE: '您输入的手机号码已被使用',
  CELLPHONE_VERIFICATION_COOLDOWN: '请稍候再请求新验证码',
  CELLPHONE_VERIFICATION_BLOCKED: '尝试次数过多，请稍后再试',
  DUPLICATE_ENTRY: '该值已被使用',
  GENERIC_ERROR: '发生错误，请重试',
  PROFILE_NOT_APPROVED: '您无权执行此操作',
  VALIDATION_ERROR: '验证错误',
  'The cellphone entered is already in use': '输入的手机号码已被使用',
  'The email entered is already in use': '输入的电子邮件已被使用',
  Registration: '注册',
  Domain: '域名',
  'Total users': '总用户数',
  previous: '上一个',
  'Total approved': '总批准数',
  '% approved': '批准率',
  'Users growth': '用户增长',
  'Approved growth': '批准增长',
  'Compare data to previous': '与之前的数据比较',
  Trimester: '季度',
  'Access list': '访问列表',
  'Security staff': '安保人员',
  'Access date': '访问日期',
  'PS user profile approved': 'PS 用户资料已批准',
  'PS user profile complete': 'PS 用户资料已完成',
  'PS user email': 'PS 用户电子邮件',
  'Has invitation in PS': '在 PS 中有邀请',
  'Download CSV': '下载 CSV',
  'Card code': '卡片代码',
  'Used QR': '已使用二维码',
  'Only with corresponding invitation': '仅限有相应邀请的',
  'Only with corresponding user in PS': '仅限在 PS 中有相应用户的',
  'Only with profile completed in PS': '仅限在 PS 中完成个人资料的',
  'Only with profile approved in PS': '仅限在 PS 中批准个人资料的',
  "Request the guest to announce it's arrival to be allowed in": '请访客通知其到达以便进入',
  'Your guest arrived to the meeting. Click here to see more':
    '您的访客已到达会议。点击此处查看更多',
  'Your have a new invite notification': '您已被 {{name}} {{surname}} 邀请参加会议',
  'The host delayed your entry to the meeting. Click here to see more':
    '接待人延迟了您进入会议。点击此处查看更多',
  'The host allowed your entry to the meeting. Click here to see more':
    '接待人允许您进入会议。点击此处查看更多',
  'The waiting time is over. We have reminded the host about your arrival':
    '等待时间已结束。我们已提醒接待人您的到来',
  'Your host requested for you to wait {{minutes}} minutes':
    '您的接待人要求您等待 {{minutes}} 分钟',
  'When your access is authorized you will be able to access directly with the QR code that will appear here':
    '当您的访问被授权后，您将能够直接使用此处出现的二维码进入',
  Close: '关闭',
  'Your arrival has been notified': '您的到来已通知',
  'Announce arrival': '通知到达',
  'Allow access': '允许进入',
  'Wait 5 minutes': '等待5分钟',
  'Wait 10 minutes': '等待10分钟',
  'Your guest arrived': '您的访客已到达',
  'The guest has been allowed access': '访客已被允许进入',
  'Allow access?': '允许进入吗？',
  'The guest has been notified of the delay': '访客已被告知延迟',
  'Delay the access?': '延迟进入吗？',
  'agenda belongs to': '议程属于',
  'You must not be wearing a facemask or anything that partially covers your face':
    '您不得佩戴口罩或任何部分遮挡脸部的物品',
  'For a better experience use Google Chrome or Microsoft Edge':
    '为获得更好的体验，请使用 Google Chrome 或 Microsoft Edge',
  'New picture': '新照片',
  'Access allowed by guards': '由警卫允许进入',
  Search: '搜索',
  'Security guard': '保安',
  'guard.access.ENTRY': '允许进入',
  'guard.access.EXIT': '允许离开',
  'guard.access.DENY_ENTRY': '拒绝进入',
  Event: '事件',
  'who.visited.who': '谁访问了谁',
  'Employees per company': '每家公司的员工',
  Local: '本地',
  'Host name': '接待人姓名',
  'Host surname': '接待人姓氏',
  'Host email': '接待人电子邮件',
  'Guest name': '访客姓名',
  'Guest surname': '访客姓氏',
  'Guest email': '访客电子邮件',
  'Guest phone': '访客电话',
  'Guest document': '访客证件',
  'Guest CPF': '访客 CPF',
  'Host company': '接待人公司',
  'Guest company': '访客公司',
  Export: '导出',
  'Order:': '订单：',
  'Badge number:': '徽章号码：',
  'Guest badge number': '访客徽章号码',
  'Date of visit': '访问日期',
  'Start time': '开始时间',
  'Finish time': '结束时间',
  'Document number': '证件号码',
  'Document type': '证件类型',
  'date-format': 'YYYY/MM/DD',
  'time-format': 'HH:mm',
  'datetime-format': 'YYYY/MM/DD HH:mm',
  'date-ampm': 'false',
  Return: '返回',
  'Profile Completed At': '资料已完成',
  'Profile Approved At': '资料已批准',
  'Profile Rejected At': '资料已拒绝',
  'Are you sure about that?': '您确定吗？',
  'Access code linked to another user': '访问代码已关联到其他用户',
  'Associate with new user': '关联新用户',
  'Unlinked user': '未关联的用户',
  Copy: '复制',
  'Taking photo': '正在拍照',
  'Send image': '发送图片',
  'Max date Error': '最长周期为3个月',
  'Min date Error': '不能早于开始日期',
  CELLPHONE_VERIFICATION_COOLDOWN: '请稍等片刻后再试',
  CELLPHONE_VERIFICATION_BLOCKED:
    '我们检测到多次重复的验证尝试，为了安全已暂时阻止发送短信。请联系客服以继续',
  'You can request a new code in {{seconds}}s': '您可以在 {{seconds}} 秒后重新请求验证码',
  'For your security, SMS sending was temporarily blocked due to repeated attempts':
    '为了您的安全，由于多次重复尝试，短信发送已被暂时阻止',
  'Please contact our support team via WhatsApp or phone to continue {{phone}}':
    '请通过 WhatsApp 或电话联系我们的客服以继续：{{phone}}',
  'Contact support on WhatsApp': '通过 WhatsApp 联系客服',
  'mcp.consent.title': '{{client}} 想要访问您的 {{brand}} 账户',
  'mcp.consent.domainLabel': '应用域名',
  'mcp.consent.unverifiedBadge': '未验证',
  'mcp.consent.unverifiedHint': '此域名由应用自行提供，未经验证。',
  'mcp.consent.accountLabel': '当前使用的账户',
  'mcp.consent.switchAccount': '不是您？切换账户',
  'mcp.consent.permissionsLabel': '您授权的权限',
  'mcp.scope.invitations:read.label': '查看您收到的邀请',
  'mcp.scope.meetings:read.label': '查看您创建或以秘书身份管理的会议，包括受邀人',
  'mcp.scope.invitations:write.label': '代表您确认或拒绝邀请',
  'mcp.scope.meetings:write.label': '创建会议并邀请他人；编辑和取消您的会议，并更改受邀人',
  'mcp.consent.writeBadge': '会更改数据',
  'mcp.consent.meetingsWriteNotice':
    '该应用将可以创建会议并邀请他人，以及编辑和取消会议。受邀人会收到电子邮件和推送通知。',
  'mcp.consent.selectAtLeastOne': '请至少勾选一项权限后继续。',
  'mcp.consent.allow': '允许',
  'mcp.consent.deny': '拒绝',
  'mcp.consent.sending': '正在发送…',
  'mcp.consent.actionError': '无法完成操作，请重试。',
  'mcp.consent.loading': '正在加载请求…',
  'mcp.consent.expired': '此请求已过期。请返回应用，重新尝试连接。',
  'mcp.consent.loadError': '无法加载请求。请检查网络连接后重试。',
  'mcp.consent.tryAgain': '重试',
  'mcp.consent.goToBrand': '前往 {{brand}}',
  'mcp.consent.profileNotApproved': '您的注册信息仍在审核中。审核通过后，请返回应用重新连接。',
  'mcp.consent.accountUnavailable': '此账户目前无法连接应用。请切换账户，或拒绝此请求以返回应用。',
  'mcp.consent.alreadyDecided': '此请求已处理。请返回应用。',
  'mcp.consent.seeConnectedApps': '查看已连接的应用',
  'mcp.connectedApps.title': '已连接的应用',
  'mcp.connectedApps.intro': '这些应用可以访问您的 {{brand}} 账户。您可以随时撤销它们的访问权限。',
  'mcp.connectedApps.permissionsLabel': '已授予的权限',
  'mcp.connectedApps.connectedOn': '连接于 {{date}}',
  'mcp.connectedApps.lastUsed': '最近使用：{{date}}',
  'mcp.connectedApps.neverUsed': '从未使用',
  'mcp.connectedApps.revoke': '撤销访问权限',
  'mcp.connectedApps.revokeConfirm':
    '撤销 {{client}}（{{domain}}）的访问权限？撤销后将立即失效，如需再次使用，需要重新连接。',
  'mcp.connectedApps.revoked': '访问权限已撤销。',
  'mcp.connectedApps.revokeError': '无法撤销访问权限，请重试。',
  'mcp.connectedApps.loadError': '无法加载您已连接的应用。',
  'mcp.connectedApps.empty': '尚未连接任何应用。连接后，它会显示在这里。',
};
